{
  "AGENT_MGMT": {
    "HEADER": "客服",
    "HEADER_BTN_TXT": "新增客服",
    "LOADING": "正在取得客服列表",
    "DESCRIPTION": "客服是您客戶支援團隊的成員，可以查看和回覆使用者訊息。以下列表顯示了您帳戶中的所有客服。",
    "LEARN_MORE": "瞭解使用者角色",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "管理員",
      "AGENT": "客服"
    },
    "COUNT": "{n} 位客服 | {n} 位客服",
    "LIST": {
      "404": "沒有與此帳戶關聯的客服",
      "TITLE": "管理您團隊中的客服",
      "DESC": "您可以新增或移除團隊中的客服。",
      "NAME": "名稱",
      "EMAIL": "電子郵件",
      "STATUS": "狀態",
      "ACTIONS": "操作",
      "VERIFIED": "已認證",
      "VERIFICATION_PENDING": "待驗證",
      "AVAILABLE_CUSTOM_ROLE": "可用的自訂角色權限"
    },
    "ADD": {
      "TITLE": "新增客服到您的團隊",
      "DESC": "您可以新增能夠處理收件匣支援的人員。",
      "CANCEL_BUTTON_TEXT": "取消",
      "FORM": {
        "NAME": {
          "LABEL": "客服名稱",
          "PLACEHOLDER": "請輸入客服名稱"
        },
        "AGENT_TYPE": {
          "LABEL": "角色",
          "PLACEHOLDER": "請選擇一個角色",
          "ERROR": "角色為必填"
        },
        "EMAIL": {
          "LABEL": "電子郵件地址",
          "PLACEHOLDER": "請輸入客服的電子郵件地址"
        },
        "SUBMIT": "新增客服"
      },
      "API": {
        "SUCCESS_MESSAGE": "客服新增成功",
        "EXIST_MESSAGE": "該電子郵件已被使用，請嘗試其他電子郵件地址",
        "ERROR_MESSAGE": "無法連接伺服器，請稍後再試"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "刪除",
      "API": {
        "SUCCESS_MESSAGE": "客服刪除成功",
        "ERROR_MESSAGE": "無法連接伺服器，請稍後再試"
      },
      "CONFIRM": {
        "TITLE": "確認刪除",
        "MESSAGE": "您確定要刪除嗎？",
        "YES": "是，刪除 ",
        "NO": "不，保留 "
      }
    },
    "EDIT": {
      "TITLE": "編輯客服",
      "FORM": {
        "NAME": {
          "LABEL": "客服名稱",
          "PLACEHOLDER": "請輸入客服名稱"
        },
        "AGENT_TYPE": {
          "LABEL": "角色",
          "PLACEHOLDER": "請選擇一個角色",
          "ERROR": "角色為必填"
        },
        "EMAIL": {
          "LABEL": "電子郵件地址",
          "PLACEHOLDER": "請輸入客服的電子郵件地址"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "上線狀態",
          "PLACEHOLDER": "請選擇上線狀態",
          "ERROR": "上線狀態為必填"
        },
        "SUBMIT": "編輯客服"
      },
      "BUTTON_TEXT": "編輯",
      "CANCEL_BUTTON_TEXT": "取消",
      "API": {
        "SUCCESS_MESSAGE": "更新客服資訊成功",
        "ERROR_MESSAGE": "無法連接伺服器，請稍後再試"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "重置密碼",
        "ADMIN_SUCCESS_MESSAGE": "一封包含重設密碼說明的電子郵件已傳送給客服",
        "SUCCESS_MESSAGE": "客服密碼重設成功",
        "ERROR_MESSAGE": "無法連接伺服器，請稍後再試"
      }
    },
    "SEARCH_PLACEHOLDER": "搜尋客服...",
    "NO_RESULTS": "找不到符合搜尋條件的客服",
    "SEARCH": {
      "NO_RESULTS": "查無結果。"
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "無",
      "TITLE": {
        "AGENT": "選擇客服",
        "TEAM": "選擇團隊"
      },
      "LIST": {
        "NONE": "無"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "找不到客服",
          "TEAM": "找不到團隊"
        },
        "PLACEHOLDER": {
          "AGENT": "搜尋客服",
          "TEAM": "搜尋團隊",
          "INPUT": "搜尋客服"
        }
      }
    }
  }
}
